export * from './AdminApi';
import AdminApi from './AdminApi';
export * from './AnswerApi';
import AnswerApi from './AnswerApi';
export * from './ArticleApi';
import ArticleApi from './ArticleApi';
export * from './BannerApi';
import BannerApi from './BannerApi';
export * from './ClassifyApi';
import ClassifyApi from './ClassifyApi';
export * from './CommentApi';
import CommentApi from './CommentApi';
export * from './FileApi';
import FileApi from './FileApi';
export * from './GroupApi';
import GroupApi from './GroupApi';
export * from './HomeApi';
import HomeApi from './HomeApi';
export * from './PointApi';
import PointApi from './PointApi';
export * from './QuestionApi';
import QuestionApi from './QuestionApi';
export * from './SearchApi';
import SearchApi from './SearchApi';
export * from './ShareApi';
import ShareApi from './ShareApi';
export * from './ShopApi';
import ShopApi from './ShopApi';
export * from './StatisticApi';
import StatisticApi from './StatisticApi';
export * from './SubjectApi';
import SubjectApi from './SubjectApi';
export * from './TagApi';
import TagApi from './TagApi';
export * from './TeamApi';
import TeamApi from './TeamApi';
export * from './ThumbUpApi';
import ThumbUpApi from './ThumbUpApi';
export * from './TopicApi';
import TopicApi from './TopicApi';
export * from './UserApi';
import UserApi from './UserApi';
export * from './VoteApi';
import VoteApi from './VoteApi';
export const APIS = {
  AdminApi,
  AnswerApi,
  ArticleApi,
  BannerApi,
  ClassifyApi,
  CommentApi,
  FileApi,
  GroupApi,
  HomeApi,
  PointApi,
  QuestionApi,
  SearchApi,
  ShareApi,
  ShopApi,
  StatisticApi,
  SubjectApi,
  TagApi,
  TeamApi,
  ThumbUpApi,
  TopicApi,
  UserApi,
  VoteApi
};
